export default __webpack_public_path__ + "static/media/Bg img 2.b5727b08.png";